<template>
  <v-dialog
    :value="show"
    width="50%"
    @input="$emit('changeValue', $event)"
    transition="dialog-transition">
    <v-card>
      <v-card-text class="pt-4 pb-4">
        <v-layout row wrap class="px-3">
          <v-flex xs12 class="text-xs-center mb-3">
            <v-icon
              slot="activator"
              class="f3-5em k-orange-linear-text"
            >
              fas fa-exclamation-triangle
            </v-icon>
          </v-flex>
          <v-flex xs12 class="text-xs-center my-2">
            <p>Se detectó que ya existe un chat cerrado asociado a ese {{channel}} el día de hoy</p>
            <p>¿Desea asignar estos mensajes al chat anterior?</p>
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-btn depressed round @click="$emit('changeValue', false)">
              CANCELAR
            </v-btn>
             <v-btn depressed round @click="doIt">
              ACEPTAR
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    chatCenter: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    channel() {
      let name = 'teléfono';
      if (this.chatCenter.channel_id === 1) {
        name = 'Email';
      }
      return name;
    },
    route() {
      return `/chats_center/${this.chatCenter.id}/replace`;
    },
  },
  methods: {
    doIt() {
      this.axios.post(this.route).then(() => {
        this.$emit('deleted');
      }).catch(() => {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/chat_center_v2/DuplicateModal.vue